import {mediaTabletAndUp, SkeletonBlock} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {WalletType} from '../utils/useActiveTab';
import {DarkSkeletonBlock} from './CoinsSkeletons';

export const WalletHeaderSkeletons: React.FC<{activeTab: WalletType}> = ({
  activeTab,
}) => {
  return (
    <Wrapper>
      {activeTab === 'coins' ? (
        <DarkSkeletonBlock $width="60%" $height="28px" disableSpaceBelow />
      ) : (
        <SkeletonBlock $width="60%" $height="28px" disableSpaceBelow />
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;

  > div {
    // 24px + 16px (close icon width + header gap size)
    margin-left: -36px;
  }

  @media ${mediaTabletAndUp} {
    // 24px + 16px (close icon width + header gap size)
    > div {
      margin-left: 36px;
    }
  }
`;
